import {cs}                              from "@Common/react/chain-services";
import {consumeContext, provideContext1} from "@Common/react/context";
import {Load2}                           from "@Common/react/load2";

export const loadCompany = (next) => cs(
    consumeContext("apis"),
    ["company", ({apis}, next) => Load2({
        fetch: () => apis.next.session.getCompany(),
        next,
    })],
    ["companyData", ({company}, next) => {
        let data = undefined;
        if(!company.loading) {
            data = company.value;
            data['reload'] = company.reload;
        }
        return next(data);
    }],
    ({companyData}, next) => provideContext1("company", companyData, next),
    ({companyData}) => next(companyData),
);
